import React from "react";
import { Helmet } from "react-helmet-async";
import {
  DEFAULT_OG_IMAGE_PATH,
  SITE_NAME,
  formatPageTitle,
  getAbsoluteAssetUrl,
  getCanonicalUrl,
} from "../../utils/pageSeo";

const PageSeo = ({
  title,
  description,
  pathname = "/",
  imagePath = DEFAULT_OG_IMAGE_PATH,
  type = "website",
  noIndex = false,
}) => {
  const canonicalUrl = getCanonicalUrl(pathname);
  const imageUrl = getAbsoluteAssetUrl(imagePath);
  const resolvedTitle = formatPageTitle(title || SITE_NAME);

  return (
    <Helmet>
      <title>{resolvedTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={resolvedTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={imageUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedTitle} />
      {description && (
        <meta name="twitter:description" content={description} />
      )}
      <meta name="twitter:image" content={imageUrl} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}
    </Helmet>
  );
};

export default PageSeo;
